import { DenormalizedCustomizableGroup, DenormalizedCustomizableQuestion } from '@packages/types'
import { animated, useSpringRef, useTransition } from '@react-spring/web'
import React, { useEffect } from 'react'

import usePrevious from 'common/hooks/usePrevious'
import { useSelector } from 'customizer/hooks'

import { selectedStepIdSelector, stepsSelector } from '../../selectors'

type AnimatedStepProps = {
  className?: string
  children: React.ReactNode
}

const AnimatedStep = ({ className, children }: AnimatedStepProps) => {
  const steps = useSelector(stepsSelector) as (DenormalizedCustomizableGroup | DenormalizedCustomizableQuestion)[]
  const selectedStepId = useSelector(selectedStepIdSelector) as string
  const lastSelectedStepId = usePrevious(selectedStepId)

  useEffect(() => {
    transRef.start()
  }, [selectedStepId])

  const isFromRight = () => {
    return steps.findIndex(step => step.id === selectedStepId) > steps.findIndex(step => step.id === lastSelectedStepId)
  }

  const transRef = useSpringRef()
  const transitions = useTransition(selectedStepId, {
    ref: transRef,
    keys: null,
    from: () => {
      if (!lastSelectedStepId) return { opacity: 0 }
      if (isFromRight()) {
        return { opacity: 0, transform: 'translate3d(10%,0,0)' }
      }
      return { opacity: 0, transform: 'translate3d(-10%,0,0)' }
    },
    enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
  })

  return transitions(style => {
    return (
      <animated.div className={className} style={style}>
        {children}
      </animated.div>
    )
  })
}

export default AnimatedStep
